module.exports = __webpack_public_path__ + "static/High School-6c5502533a7a3f0c3aaef6818dd3c5d9.png";